module.exports = __webpack_public_path__ + "img/rule_bg.b75bda42.png";